import { createContext } from 'react';

const statisticsContext = createContext();

export default statisticsContext;
